import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Vermont = () => {
  return (
    <StatePropertyTaxPage
      stateName="Vermont"
      processDescription="Property owners may appeal their assessment by filing with the local board of civil authority or board of abatement within 30 days of the mailing of the grand list. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="June"
      noticeOfValueMailedDateExplanation="Grand list notices are typically mailed in June following the completion of annual assessments."
      valuationAsOfDate="April 1"
      valuationAsOfDateExplanation="Vermont assesses property as of April 1 each year. This spring assessment date captures property values as properties emerge from winter conditions."
      deadlineExplanation="Property owners have 30 days from the mailing of the grand list to file appeals. This typically results in a July deadline."
    />
  );
};

export default Vermont;